import { render, staticRenderFns } from "./puUpList.vue?vue&type=template&id=409abe5a&scoped=true"
import script from "./puUpList.vue?vue&type=script&lang=js"
export * from "./puUpList.vue?vue&type=script&lang=js"
import style0 from "./puUpList.vue?vue&type=style&index=0&id=409abe5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409abe5a",
  null
  
)

export default component.exports